import { render, staticRenderFns } from "./EditGeofence.vue?vue&type=template&id=5b8d9c4c&scoped=true"
import script from "./EditGeofence.vue?vue&type=script&lang=js"
export * from "./EditGeofence.vue?vue&type=script&lang=js"
import style0 from "./EditGeofence.vue?vue&type=style&index=0&id=5b8d9c4c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8d9c4c",
  null
  
)

export default component.exports